const favoritedMediaItemsPrefix = accountId => `/${accountId}/favorited-media-items`;
const favoriteItemPrefix = (accountId, thumbnailUrl, isFavorited) =>
    `${favoritedMediaItemsPrefix(accountId)}/favorite-item?thumbnailUrl=${thumbnailUrl}&isFavorited=${isFavorited}`;

export const favoritedMediaItemsApiFactory = ({ callPostApi }) => ({
    favoriteMediaItem: (accountId, thumbnailUrl, isFavorited) =>
        callPostApi(`${favoriteItemPrefix(accountId, thumbnailUrl, isFavorited)}`, null, null, true),
});
